// import { luminate, saturate } from 'everyday-utils'
import { reactive } from 'minimal-view'
import themes from 'plenty-themes/_all.json'

export type Theme = typeof themes[0]

export type Skin = typeof Skin.State

export const Skin = reactive('skin',
  class props {
  },
  class local {
    rootDir?: string
    theme: Theme =
      localStorage.theme
        ? JSON.parse(localStorage.theme) as Theme
        : themes[10]

    colors = {
      fg: '#fff',
      bg: '#000',
      black: '#000',
      red: "#db2d20",
      green: "#01a252",
      yellow: "#fded02",
      blue: "#01a0e4",
      purple: "#a16a94",
      cyan: "#b5e4f4",
      white: "#a5a2a2",
      brightBlack: "#5c5855",
      brightRed: "#e8bbd0",
      brightGreen: "#3a3432",
      brightYellow: "#4a4543",
      brightBlue: "#807d7c",
      brightPurple: "#d6d5d4",
      brightCyan: "#cdab53",
      brightWhite: "#f7f7f7",
    }

    fonts = {
      // logo: '"Baumans", cursive',
      sans: '"Jost", sans-serif',
      // slab: '"Geo", monospace',
      mono: '"JetBrains Mono", monospace',
      // cond: '"Barlow Semi Condensed", sans-serif',
    }

    fontFaces?: FontFace[] = []
  },
  function actions({ $, fn, fns }) {
    return fns(new class actions {
    })
  },
  function effects({ $, fx, deps }) {
    // fx(async ({ rootDir }) => {
    //   const fontFaces: FontFace[] = []
    //   for (const [name, kinds] of [['Jost', [
    //     ['100', 'normal', 'Light'],
    //     ['100', 'italic', 'LightItalic'],
    //   ]], ['JetBrains Mono', [
    //     ['100', 'normal', 'Thin'],
    //     ['100', 'italic', 'ThinItalic'],
    //   ]]] as const) {
    //     for (const [weight, style, file] of kinds) {
    //       const fontFace = new FontFace(name, `url(${rootDir + `/fonts/${name.replace(/\s+/, '_')}/static/${name.replace(/\s+/, '')}-${file}.ttf`})`, { weight, style })
    //       fontFaces.push(fontFace)
    //     }
    //   }

    //   const loadedFonts = await Promise.all(
    //     fontFaces.map((fontFace) => fontFace.load())
    //   )

    //   loadedFonts.forEach((font) =>
    //     document.fonts.add(font)
    //   )

    //   await document.fonts.ready

    //   $.fontFaces = fontFaces
    // })

    fx(({ theme }) => {
      $.colors = {
        fg: theme.brightWhite,
        bg: theme.background,
        // black: '#080808',
        // white: theme.white,
        // grey: luminate(saturate(theme.white, -1), -0.39),
        // dark: luminate(saturate(theme.white, -1), -0.5),
        ...theme
      }
      // console.log($.colors)
    })
    fx(({ theme }) => {
      localStorage.theme = JSON.stringify(theme)
    })
  }
)

export const skin = Skin({})
